import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ResultType } from '../models/enums/result-type.enum';
import { CustomToastrComponent } from '../shared/Toaster/custom-toastr/custom-toastr.component';

@Injectable({
    providedIn: 'root',
})
export class CustomToastService {
    constructor(private toastrService: ToastrService) {}

    // Generic toast
    genericToast(type: ResultType, title?: string) {
        switch (type) {
            case ResultType.Success:
                this.successToast('Successfull done.', title);
                break;
            case ResultType.Error:
                this.errorToast('Sorry, looks like there are some errors detected, please try again.', title);
                break;
            case ResultType.Warning:
                this.warningToast('Warning!', title);
                break;
        }
    }

    // success toast
    successToast(message: string, title?: string) {
        // specify our custom component type so the returned ActiveToast is typed correctly
        const successToastRef = this.toastrService.show<CustomToastrComponent>(message, title);
        if (successToastRef) {
            successToastRef.toastRef.componentInstance.case = 'success';
        }
    }

    // error toast
    errorToast(message: string, title?: string) {
        const errorToastRef = this.toastrService.show<CustomToastrComponent>(message, title);
        if (errorToastRef) {
            errorToastRef.toastRef.componentInstance.case = 'error';
        }
    }

    // error toast
    warningToast(message: string, title?: string) {
        const warningToastRef = this.toastrService.show<CustomToastrComponent>(message, title);
        if (warningToastRef) {
            warningToastRef.toastRef.componentInstance.case = 'warning';
        }
    }

    // info toast
    infoToast(message: string, title?: string) {
        const infoToastRef = this.toastrService.show<CustomToastrComponent>(message, title);
        if (infoToastRef) {
            infoToastRef.toastRef.componentInstance.case = 'info';
        }
    }
}
